import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { motion } from "framer-motion";
import Avatar from "../assests/Avatar.webp";
import WomenAvatar from "../assests/womenAvatar.webp";
import WomenAvatar2 from "../assests/WomenAvatar2.webp";
import Learning from "./Learning";

const MotionCard = motion(Card);

const facultyData = [
  {
    name: "Mr. Rajesh Sharma",
    role: "Maths Specialist",
    qualification: "M.Sc. Mathematics",
    experience: "15+ Years Experience",
    image: Avatar,
    description:
      "Former DPS Faculty with expertise in Algebra, Geometry, and Olympiad preparation. Known for making mathematical concepts simple and engaging for students.",
  },
  {
    name: "Dr. Priya Menon",
    role: "Science Expert",
    qualification: "PhD Chemistry",
    experience: "12+ Years Experience",
    image: WomenAvatar,
    description:
      "Expert in Physics, Chemistry, and Biology with a strong focus on practical learning, experiments, and concept-based teaching methods.",
  },
  {
    name: "Ms. Anjali Verma",
    role: "Languages Expert",
    qualification: "MA Literature",
    experience: "10+ Years Experience",
    image: WomenAvatar2,
    description:
      "Specialist in Hindi, Sanskrit, and English. Helps students improve communication skills, grammar, writing, and public speaking confidence.",
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export default function Faculty() {
  return (
    <>
      <Box
        sx={{
          py: { xs: 7, md: 10 },
          background: "#fff",
        }}
      >
        <Container maxWidth="lg">
          {/* Heading */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            textAlign="center"
            mb={7}
          >
            <Typography
              sx={{
                color: "#FF6B00",
                fontWeight: 700,
                letterSpacing: 2,
                mb: 1,
                fontSize: "13px",
              }}
            >
              OUR FACULTY
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "25px",
                  sm: "30px",
                  md: "32px",
                },
                fontWeight: 800,
                color: "#121212",
                mb: 2,
              }}
            >
              Meet Our Expert Teachers
            </Typography>

            <Typography
              sx={{
                color: "#666",
                maxWidth: "650px",
                mx: "auto",
                fontSize: "15px",
                lineHeight: 1.8,
              }}
            >
            </Typography>
          </Box>

          {/* Faculty Cards */}
          <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {facultyData.map((faculty, index) => (
              <MotionCard
                key={index}
                variants={cardVariants}
                whileHover={{
                  y: -5,
                  boxShadow: "0px 15px 35px rgba(255,107,0,0.10)",
                }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                sx={{
                  borderRadius: "24px",
                  overflow: "hidden",
                  border: "1px solid #FFE5D0",
                  boxShadow: "none",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      md: "row",
                    },
                  }}
                >
                  {/* Left Section */}
                  <Box
                    sx={{
                      width: {
                        xs: "100%",
                        md: 220,
                      },
                      background:
                        "#17B169",
                      color: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      py: { xs: 3, md: 4 },
                      px: 2,
                    }}
                  >
                    <Box
                      component={motion.img}
                      whileHover={{ scale: 1.08 }}
                      transition={{ type: "spring", stiffness: 300, damping: 15 }}
                      src={faculty.image}
                      alt={faculty.name}
                      sx={{
                        width: 110,
                        height: 110,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border:
                          "4px solid rgba(255,255,255,0.4)",
                        boxShadow:
                          "0 8px 20px rgba(0,0,0,0.15)",
                      }}
                    />

                    <Typography
                      sx={{
                        mt: 2,
                        fontWeight: 700,
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      {faculty.experience}
                    </Typography>
                  </Box>

                  {/* Right Section */}
                  <CardContent
                    sx={{
                      flex: 1,
                      p: { xs: 2.5, sm: 3, md: 4 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "21px", sm: "24px" },
                        fontWeight: 800,
                        color: "#121212",
                      }}
                    >
                      {faculty.name}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#FF6B00",
                        fontWeight: 700,
                        fontSize: "16px",
                        mt: 1,
                      }}
                    >
                      {faculty.role}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#555",
                        fontWeight: 600,
                        fontSize: "14px",
                        mt: 1,
                        mb: 2,
                      }}
                    >
                      {faculty.qualification}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: 1.8,
                      }}
                    >
                      {faculty.description}
                    </Typography>
                  </CardContent>
                </Box>
              </MotionCard>
            ))}
          </Box>
        </Container>
      </Box>
      <Learning />
    </>
  );
}